import {useState, useEffect, useMemo} from 'react'
import {ReactComponent as SearchIcon} from '../../../assets/icons/search.svg'
import {debounce} from 'lodash'
import {getCatalogCategories} from '../../../services/ProductLinesServices'
import Select from '../../../shared/Select'

const SearchFilters = ({onFilterChange, filters, setFilters}) => {
    const [categories, setCategories] = useState([])
    const [searchValue, setSearchValue] = useState(filters.search || '')
    
    const productTypeOptions = [
        { label: 'All products', value: 'all' },
        { label: 'Shopify product', value: 'shopify' }
    ]

    const onProductTypeChange = (option) => {
        const value = option.value
        const newFilters = {
            ...filters,
            productType: value,
        }
        onFilterChange(newFilters)
        setFilters(newFilters)
    }
    const onCategoryChange = (option) => {
        const value = option ? option.value : ''
        const newFilters = {
            ...filters,
            category: value,
        }
        onFilterChange(newFilters)
        setFilters(newFilters)
    }
    
    const debouncedSearch = useMemo(
        () => debounce((value) => {
            const newFilters = {
                ...filters,
                search: value,
            }
            onFilterChange(newFilters)
            setFilters(newFilters)
        }, 400),
        []
    )

    const handleSearchChange = (e) => {
        const value = e.target.value
        setSearchValue(value)
        debouncedSearch(value)
    }
    
    useEffect(() => {
        return () => {
            debouncedSearch.cancel()
        }
    }, [debouncedSearch])

    useEffect(() => {
        getCatalogCategories().then((resp) => {
            const formattedCategories = resp.data.map((category) => ({
                id: category._id,
                name: category.name,
                label: category.name,
                value: category._id,
            }))
            setCategories([
                { id: '', name: 'All Categories', label: 'All Categories', value: '' },
                ...formattedCategories
            ])
        })
    }, [])


    return (
        <div className="filters">
            <Select
                className="filter-select"
                value={productTypeOptions.find(option => option.value === filters.productType) || productTypeOptions[0]}
                onChange={onProductTypeChange}
                options={productTypeOptions}
                isSearchable={false}
            />

            <Select
                className="filter-select"
                value={categories.find(category => category.value === filters.category) || null}
                onChange={onCategoryChange}
                options={categories}
                placeholder="All"
                isSearchable={false}
            />

            <div className="search-input">
                <SearchIcon />
                <input
                    type="text"
                    value={searchValue}
                    placeholder="Search for product title..."
                    onChange={handleSearchChange}
                />
            </div>
        </div>
    )
}

export default SearchFilters

